function initTabs() {
  const wrapSelector = '.js-tabs';
  const tabListSelector = '.js-tabs-list';
  const tabItemSelector = '.js-tabs-item';
  const tabPanelSelector = '.js-tabs-panel';

  const wrapList = document.querySelectorAll(wrapSelector);
  if (!wrapList.length) return;

  function switchTab(oldTab, newTab, tabDefaultClassArray = [], tabActiveClassArray = []) {
    newTab.dispatchEvent(new Event('focus', {bubbles: true}));
    newTab.classList.remove(...tabDefaultClassArray);
    newTab.classList.add(...tabActiveClassArray);
    newTab.removeAttribute('tabindex');
    newTab.setAttribute('aria-selected', 'true');

    oldTab.classList.remove(...tabActiveClassArray);
    oldTab.classList.add(...tabDefaultClassArray);
    oldTab.removeAttribute('aria-selected');
    oldTab.setAttribute('tabindex', '-1');

    const oldPanel = document.querySelector(oldTab.getAttribute('href'));
    const newPanel = document.querySelector(newTab.getAttribute('href'));

    if (!oldPanel || !newPanel) return;

    oldPanel.classList.add('hidden');
    newPanel.classList.remove('hidden');
  }

  for (let i = 0; i < wrapList.length; i++) {
    const wrapper = wrapList[i];

    const tabList = wrapper.querySelector(tabListSelector);
    if (!tabList) continue;

    let tabDefaultClassArray = ['border-transparent', 'hover:border-gray-300', 'text-gray-600'];
    let tabActiveClassArray = ['bg-white', 'text-indigo-700'];

    if (tabList.hasAttribute('data-default-class')) {
      tabDefaultClassArray = tabList.getAttribute('data-default-class').split(' ');
    }

    if (tabList.hasAttribute('data-active-class')) {
      tabActiveClassArray = tabList.getAttribute('data-active-class').split(' ');
    }

    tabList.addEventListener('click', (e) => {
      const tab = e.target.closest(tabItemSelector);
      if (!tab) return;

      e.preventDefault();

      const activeTab = tabList.querySelector('[aria-selected="true"]');

      if (tab !== activeTab) {
        switchTab(activeTab, tab, tabDefaultClassArray, tabActiveClassArray);
      }
    });
  }

  /*  // Get relevant elements and collections
    const tabbed = document.querySelector('.tabbed');
    const tablist = tabbed.querySelector('ul');
    const tabs = tablist.querySelectorAll('a');
    const panels = tabbed.querySelectorAll('[id^="section"]');*/

  /*// Add semantics are remove user focusability for each tab
  Array.prototype.forEach.call(tabs, (tab, i) => {
    // Handle clicking of tabs for mouse users
    tab.addEventListener('click', e => {
      e.preventDefault();
      let currentTab = tablist.querySelector('[aria-selected]');
      if (e.currentTarget !== currentTab) {
        switchTab(currentTab, e.currentTarget);
      }
    });

    // Handle keydown events for keyboard users
    tab.addEventListener('keydown', e => {
      // Get the index of the current tab in the tabs node list
      let index = Array.prototype.indexOf.call(tabs, e.currentTarget);
      // Work out which key the user is pressing and
      // Calculate the new tab's index where appropriate
      let dir = e.which === 37 ? index - 1 : e.which === 39 ? index + 1 : e.which === 40 ? 'down' : null;
      if (dir !== null) {
        e.preventDefault();
        // If the down key is pressed, move focus to the open panel,
        // otherwise switch to the adjacent tab
        dir === 'down' ? panels[i].focus() : tabs[dir] ? switchTab(e.currentTarget, tabs[dir]) : void 0;
      }
    });
  });*/
}

export {initTabs};
